export default {_name:'image',module:'Field',view:'Element/Image',options:{key:'image',ms:7,sm:7,xs:12}}